interface ConfirmOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pickupEndTime: string | null;
}

const ConfirmOrderModal = ({
  isOpen,
  onClose,
  onConfirm,
  pickupEndTime,
}: ConfirmOrderModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-lg max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4">정말로 주문을 확정할까요?</h2>
        <div className="mb-4 text-start">
          <p className="text-xl text-gray-600 mb-2">👋 조기확정 시 고객은</p>
          <p className="text-xl text-blue-600 underline">
            지금 이 시점부터
            <br />
            {pickupEndTime} 까지 픽업이 가능해요!
          </p>
          <p className="text-xl text-gray-600 mt-2">
            조기 확정을 원하시면 확인을 눌러주세요
          </p>
        </div>
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-500 text-white px-3 py-1 rounded"
            onClick={onClose}
          >
            취소
          </button>
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded"
            onClick={onConfirm}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmOrderModal;
